import { Heart } from "lucide-react";
import { GoldDivider } from "./Ornaments";

export default function InvitationText({ details }) {
  return (
    <section data-testid="invitation-text-section" className="mx-auto max-w-sm space-y-5 text-center">
      <p className="font-editorial text-[17px] italic leading-relaxed text-[#57534E]">
        ზოგიერთი შეხვედრა უბრალოდ
        <br />
        შემთხვევითობა არ არის...
        <br />
        ისინი ჩვენი ცხოვრების ყველაზე
        <br />
        ლამაზი დასაწყისია.
      </p>

      <p className="font-editorial text-[17px] italic leading-relaxed text-[#57534E]">
        ჩვენი გზები ერთმანეთს შეხვდა,
        <br />
        სიყვარულმა კი ერთ გზაზე დაგვაყენა.
      </p>

      <p className="font-editorial text-[17px] italic leading-relaxed text-[#57534E]">
        ახლა, როდესაც ერთმანეთს ვპირდებით
        <br />
        ერთად გავიაროთ მთელი ცხოვრება,
        <br />
        გვინდა ეს განსაკუთრებული დღე
        <br />
        ჩვენთვის ძვირფას ადამიანებთან
        <br />
        ერთად გავიზიაროთ.
      </p>

      <div className="space-y-1.5 pt-2">
        <p className="font-display gold-text text-sm uppercase tracking-[0.2em]">
          {details.date} | 18:00
        </p>
        <p className="text-sm tracking-[0.08em] text-[#44403C]">სარიტუალო დარბაზი „ლიდერი“</p>
      </div>

      <GoldDivider />

      <p className="font-editorial text-lg italic leading-relaxed text-[#44403C]">
        გელოდებით ჩვენს ყველაზე
        <br />
        ლამაზ დღეს.{" "}
        <Heart
          size={14}
          className="mb-0.5 inline text-[#D4AF37]"
          fill="currentColor"
          aria-hidden="true"
        />
      </p>

      <p className="font-editorial text-2xl italic text-[#1C1917]">
        {details.name1} & {details.name2}
      </p>
    </section>
  );
}
